import React, { useContext, useState } from 'react'
import BigModal from '../../../components/Modals/BigModal'
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../services/API'
import { EventMetaContext, ShiftContext } from './SingleEvent'

const ConfirmCancelled = ({ setAnchorEl, open, setOpen }) => {
  const { eventMeta, loadEvent } = useContext(EventMetaContext)
  const { shifts } = useContext(ShiftContext)
  const [reason, setReason] = useState('')

  const hasShiftApplicationsPending = (shifts ?? []).some((shift) =>
    shift?.applications?.some(
      (application) => application.status === 'Pending',
    ),
  )

  const handleSubmit = (e) => {
    e.preventDefault()
    API.put('/edit-event', {
      eventID: eventMeta._id,
      statusUpdate: true,
      cancellationReason: reason,
      status: 'Cancelled',
      prevStatus: eventMeta.status,
    })
      .then((res) => {
        if (res.status === 200) {
          loadEvent()
          setAnchorEl(null)
          setOpen(false)
          setReason('')
        }
      })
      .catch((e) => console.log(e))
  }
  const staffList = shifts.reduce((accumulator, shift) => {
    if (!shift.assignedTo) {
      return accumulator
    } else if (accumulator.some((x) => x._id === shift.assignedTo?._id)) {
      return accumulator
    } else {
      accumulator.push(shift.assignedTo)
      return accumulator
    }
  }, [])

  console.log('staffList', staffList)

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Cancel Event</DialogTitle>
      {hasShiftApplicationsPending ? (
        <DialogContent>
          <Alert severity="error">
            You need to review Pending Shift Applications First
          </Alert>
        </DialogContent>
      ) : (
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            component="form"
            onSubmit={handleSubmit}
          >
            <DialogContentText>
              Marking this event as cancelled will prevent resource allocation
              and medical planning.
            </DialogContentText>
            {staffList.length > 0 && (
              <Alert severity="error">
                <AlertTitle>
                  This event has staff already assigned. Cancelling the event
                  will remove shifts for the following staff:
                </AlertTitle>
                <Typography variant="caption">
                  {staffList.map((x) => (
                    <li key={x._id}>
                      {x?.userAccount?.firstName} {x?.userAccount?.lastName}
                    </li>
                  ))}
                </Typography>
                <AlertTitle sx={{ marginTop: 2 }}>
                  AmbuNet does not currently email the above staff to inform
                  them of this cancellation. Please ensure that staff are aware.
                </AlertTitle>
              </Alert>
            )}
            <TextField
              value={reason}
              autoComplete="off"
              multiline
              required
              onChange={(e) => setReason(e.target.value)}
              label="Reason for Cancelling"
              fullWidth
              size="small"
            />
            <DialogActions>
              <Button
                type="button"
                variant="outlined"
                color="error"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" color="success" type="submit">
                Confirm Status Update
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  )
}

export default ConfirmCancelled
